import React from "react";

export default function ObBondsNotFound() {
    return <div className="no-bond">
        No products found
    </div>
}